import { Form, Select } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import mask from '../../../utils/mask';
import TextFilter from '../../../components/TextFilter';

export const SelectParceiro: React.FC = () => {
  const { Option } = Select;
  const parceiro = useSelector((state: ApplicationState) => state.auth.user?.inscricoesEstaduais) || [];

  return (
    <Form.Item label={<TextFilter>Parceiro</TextFilter>} name="codParceiro">
      <Select
        placeholder="Selecione um parceiro"
        showSearch
        filterOption={(inputValue, element) =>
          element?.props.children
            .toString()
            .toLowerCase()
            .replace(/\.|-|\//g, '')
            .includes(inputValue.replace(/\.|-|\//g, '').toLowerCase())
        }
      >
        {parceiro?.length !== 0 ? (
          parceiro?.map((data, index) => (
            <Option
              key={data.codParceiro + index}
              className="optionselect"
              value={data.codParceiro}
            >
              {mask('camelCase', data.nomeParceiro)} - {data.codParceiro}
              <br />
              CNPJ/CPF: {mask('cpfCnpj', data.cnpjcpf)} <br />
              Inscrição estadual: {data.inscricaoEstadual} <br />
              <hr />
            </Option>
          ))
        ) : (
          <Option value={-1} disabled>
            Não há vínculo com nenhum parceiro
          </Option>
        )}
      </Select>
    </Form.Item>
  );
};
